import { useEffect, useState } from 'react';
import NeedsManager from '@utils/NeedsManager';
import { IForm } from '@ts/ui-models';
import { Select } from '@ts/storybook';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { useAppDispatch } from '@redux/store';

const defaultLanguageForm = (props: IForm) => {
  const { values, onCallbackChange } = props;
  const dispatch = useAppDispatch();

  const [listLanguages, setListLanguages] = useState<{ code: string; name: string }[]>([]);

  useEffect(() => {
    const loadLanguages = async () => {
      const result = await dispatch(
        fetchData({
          url: '/api/appLanguages',
        })
      );
      if (result?.payload?.data) {
        setListLanguages(result.payload.data);
      }
    };
    loadLanguages();
  }, []);

  return (
    <Select
      label={'Default language'}
      value={values.value.defaultLanguage}
      onChange={onCallbackChange('value.defaultLanguage')}
      options={listLanguages.map(language => ({ label: language.name, value: language.code }))}
    />
  );
};

export default defaultLanguageForm;
